const toggleBackdrop = () => {
  document.querySelector('.a-backdrop').classList.toggle('active');
}

export default toggleBackdrop;
